<template>
    <div :class="layout">
        <div class="text">
            <div>{{ label }}</div>
            <div class="copy" :class="{ copying }" @click="copy" role="button" tabindex="0">
                <i class="far fa-copy"></i>
                <span class="btnLabel">{{ tr.copy }}</span>
                <span class="btnLabel animation">{{ tr.copied }}</span>
            </div>
        </div>
        <div class="url" :class="{ monospace: hide }" @copy.prevent="copy">
            <span ref="display">{{ displayText }}</span>
            <i
                v-if="hide"
                class="toggle far"
                :class="{ 'fa-eye': isHidden, 'fa-eye-slash': !isHidden }"
                @click="hiding = !hiding"
            ></i>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { dom } from '../utils';

    export default {
        data() {
            return {
                copying: false,
                hiding: true,
            };
        },
        props: {
            label: String,
            text: {
                type: String,
                required: true,
            },
            layout: {
                type: String,
                default: 'vertical',
            },
            hide: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapGetters({
                tr: 'lang/tr',
            }),
            isHidden() {
                return this.hide && this.hiding;
            },
            displayText() {
                return this.isHidden ? '•'.repeat(this.text.length) : this.text;
            },
        },
        methods: {
            async copy() {
                this.copying = true;
                const initHidden = this.isHidden;
                if (initHidden) {
                    this.hiding = false;
                    await this.$nextTick();
                }
                dom.copyText(this.$refs.display.innerText);
                if (initHidden) {
                    this.hiding = true;
                } else {
                    dom.select(this.$refs.display);
                }
                setTimeout(() => (this.copying = false), 1000);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .horizontal {
        display: flex;
        align-items: center;

        .text {
            order: 2;
        }

        .url {
            margin-top: 0;
            margin-right: 0.75em;
        }
    }

    .text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: $bold;
    }

    .copy {
        cursor: pointer;
        position: relative;
        text-align: right;
        font-weight: normal;
        white-space: nowrap;

        .btnLabel {
            display: inline-block;
            text-align: left;
            width: 55px;
            padding-left: 5px;
        }

        .animation {
            position: absolute;
            right: 0;
            color: $color-highlight;
            transition: opacity 0.4s ease-in;
            opacity: 0;
        }

        &.copying .animation {
            animation: floatup 1s ease-in-out;
        }

        &:hover {
            color: $color-main;
        }
    }

    .url {
        @include border;
        @include border-radius-small;

        background: $color-disabled-bg;
        margin-top: 0.5em;
        padding: 0.75em 1em;
        word-break: break-all;
    }

    @keyframes floatup {
        20% {
            opacity: 0.999;
        }

        to {
            transform: translateY(-2em);
        }
    }

    .toggle {
        cursor: pointer;
        width: 1.4em;
        text-align: center;
        margin-left: 0.7em;
        color: $color-label;

        &:hover {
            color: $color-black;
        }
    }
</style>